module.exports = __webpack_public_path__ + "static/media/logo.dafed18b.svg";